import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { updateSetting } from "../../../services/settingsService";
import { getSettings } from "../../../services/settingsService";

const ContactSocial = ({ contactSocial, setContactSocial }) => {
    const [localContactSocial, setLocalContactSocial] = useState({
        // Contact Information
        contact_email: '',
        contact_phone: '',
        contact_address: '',
        contact_city: '',
        contact_state: '',
        contact_country: '',
        contact_zip: '',
        website_url: '',
        
        // Social Media Links
        facebook_url: '',
        twitter_url: '',
        instagram_url: '',
        linkedin_url: '',
        youtube_url: '',
        whatsapp_number: '',
        telegram_username: '',
        skype_username: '',
        viber_number: '',
        snapchat_username: '',
        tiktok_url: '',
        pinterest_url: '',
        reddit_url: '',
        discord_invite: '',
        twitch_url: '',
        
        // Professional Networks
        github_url: '',
        behance_url: '',
        dribbble_url: '',
        medium_url: '',
        deviantart_url: '',
        flickr_url: '',
        tumblr_url: '',
        vimeo_url: '',
        
        
        // App Stores
        google_play_url: '',
        app_store_url: '',
        microsoft_store_url: ''
    });

    useEffect(() => {
        if (contactSocial && Object.keys(contactSocial).length > 0) {
            setLocalContactSocial(prev => ({ ...prev, ...contactSocial }));
        }
    }, [contactSocial]);

    useEffect(() => {
        getSettings().then(settings => {
            setContactSocial(settings);
        });
    }, []);

    const handleChange = (field, value) => {
        const updated = { ...localContactSocial, [field]: value };
        setLocalContactSocial(updated);
        setContactSocial(updated);
    };

    const handleSave = async () => {
        try {
            const updates = Object.keys(localContactSocial).map(key =>
                updateSetting(key, localContactSocial[key])
            );

            const results = await Promise.all(updates);
            const allSuccessful = results.every(result => result);

            if (allSuccessful) {
                toast.success("Contact & Social settings saved successfully!");
            } else {
                toast.error("Some settings failed to save");
            }
        } catch (error) {
            console.error("Error saving contact & social settings:", error);
            toast.error("Failed to save contact & social settings");
        }
    };

    const resetToDefault = () => {
        const defaultValues = {
            contact_email: '',
            contact_phone: '',
            contact_address: '',
            contact_city: '',
            contact_state: '',
            contact_country: '',
            contact_zip: '',
            website_url: '',
            facebook_url: '',
            twitter_url: '',
            instagram_url: '',
            linkedin_url: '',
            youtube_url: '',
            whatsapp_number: '',
            telegram_username: '',
            skype_username: '',
            viber_number: '',
            snapchat_username: '',
            tiktok_url: '',
            pinterest_url: '',
            reddit_url: '',
            discord_invite: '',
            twitch_url: '',
            github_url: '',
            behance_url: '',
            dribbble_url: '',
            medium_url: '',
            deviantart_url: '',
            flickr_url: '',
            tumblr_url: '',
            vimeo_url: '',
            google_play_url: '',
            app_store_url: '',
            microsoft_store_url: ''
        };
        setLocalContactSocial(defaultValues);
        setContactSocial(defaultValues);
        toast.info("Contact & Social settings reset to default.");
    };

    const socialMediaFields = [
        {
            group: "Contact Information",
            fields: [
                { key: "contact_email", label: "Contact Email", type: "email", placeholder: "contact@example.com" },
                { key: "contact_phone", label: "Contact Phone", type: "tel", placeholder: "+1 (555) 123-4567" },
                { key: "contact_address", label: "Address", type: "text", placeholder: "123 Main Street" },
                { key: "contact_city", label: "City", type: "text", placeholder: "New York" },
                { key: "contact_state", label: "State/Province", type: "text", placeholder: "NY" },
                { key: "contact_country", label: "Country", type: "text", placeholder: "United States" },
                { key: "contact_zip", label: "ZIP/Postal Code", type: "text", placeholder: "10001" },
                { key: "website_url", label: "Website URL", type: "url", placeholder: "https://www.example.com" }
            ]
        },
        {
            group: "Social Media",
            fields: [
                { key: "facebook_url", label: "Facebook", type: "url", placeholder: "https://facebook.com/yourpage" },
                { key: "twitter_url", label: "Twitter", type: "url", placeholder: "https://twitter.com/yourhandle" },
                { key: "instagram_url", label: "Instagram", type: "url", placeholder: "https://instagram.com/yourhandle" },
                { key: "linkedin_url", label: "LinkedIn", type: "url", placeholder: "https://linkedin.com/in/yourprofile" },
                { key: "youtube_url", label: "YouTube", type: "url", placeholder: "https://youtube.com/yourchannel" },
                { key: "tiktok_url", label: "TikTok", type: "url", placeholder: "https://tiktok.com/@yourhandle" },
                { key: "pinterest_url", label: "Pinterest", type: "url", placeholder: "https://pinterest.com/yourprofile" },
                { key: "reddit_url", label: "Reddit", type: "url", placeholder: "https://reddit.com/user/yourusername" }
            ]
        },
        {
            group: "Messaging & Communication",
            fields: [
                { key: "whatsapp_number", label: "WhatsApp Number", type: "tel", placeholder: "+1 (555) 123-4567" },
                { key: "telegram_username", label: "Telegram Username", type: "text", placeholder: "@yourusername" },
                { key: "skype_username", label: "Skype Username", type: "text", placeholder: "your.username" },
                { key: "viber_number", label: "Viber Number", type: "tel", placeholder: "+1 (555) 123-4567" },
                { key: "snapchat_username", label: "Snapchat Username", type: "text", placeholder: "yourusername" },
                { key: "discord_invite", label: "Discord Invite", type: "url", placeholder: "https://discord.gg/yourinvite" },
                { key: "twitch_url", label: "Twitch", type: "url", placeholder: "https://twitch.tv/yourchannel" }
            ]
        },
        {
            group: "Professional Networks",
            fields: [
                { key: "github_url", label: "GitHub", type: "url", placeholder: "https://github.com/yourusername" },
                { key: "behance_url", label: "Behance", type: "url", placeholder: "https://behance.net/yourprofile" },
                { key: "dribbble_url", label: "Dribbble", type: "url", placeholder: "https://dribbble.com/yourprofile" },
                { key: "medium_url", label: "Medium", type: "url", placeholder: "https://medium.com/@yourusername" },
                { key: "deviantart_url", label: "DeviantArt", type: "url", placeholder: "https://deviantart.com/yourusername" },
                { key: "flickr_url", label: "Flickr", type: "url", placeholder: "https://flickr.com/photos/yourusername" },
                { key: "tumblr_url", label: "Tumblr", type: "url", placeholder: "https://yourblog.tumblr.com" },
                { key: "vimeo_url", label: "Vimeo", type: "url", placeholder: "https://vimeo.com/yourchannel" }
            ]
        },
        {
            group: "App Stores",
            fields: [
                { key: "google_play_url", label: "Google Play Store", type: "url", placeholder: "https://play.google.com/store/apps/details?id=your.app" },
                { key: "app_store_url", label: "Apple App Store", type: "url", placeholder: "https://apps.apple.com/app/your-app/id123456789" },
                { key: "microsoft_store_url", label: "Microsoft Store", type: "url", placeholder: "https://www.microsoft.com/store/productId/yourproduct" }
            ]
        }
    ];

    return (
        <div className="dc-tabscontent tab-content">
            <div className="dc-personalskillshold tab-pane active fade show" id="dc-skills">
                <div className="dc-yourdetails dc-tabsinfo">
                    <div className="dc-tabscontenttitle">
                        <h3>Contact & Social Media Settings</h3>
                        <p>Manage your contact information and social media links</p>
                    </div>

                    <div className="dc-formtheme dc-userform">
                        {socialMediaFields.map((group, groupIndex) => (
                            <div key={groupIndex} className="contact-group" style={{ marginBottom: '30px' }}>
                                <h4 style={{
                                    color: '#333',
                                    borderBottom: '2px solid #007bff',
                                    paddingBottom: '10px',
                                    marginBottom: '20px'
                                }}>
                                    {group.group}
                                </h4>

                                <div className="row">
                                    {group.fields.map((field, fieldIndex) => (
                                        <div key={fieldIndex} className="col-md-6 col-sm-12" style={{ marginBottom: '15px' }}>
                                            <div className="form-group">
                                                <label style={{
                                                    color: '#333',
                                                    fontWeight: 'bold',
                                                    marginBottom: '5px',
                                                    display: 'block'
                                                }}>
                                                    {field.label}
                                                </label>
                                                <input
                                                    type={field.type}
                                                    className="form-control"
                                                    placeholder={field.placeholder}
                                                    value={localContactSocial[field.key] || ''}
                                                    onChange={(e) => handleChange(field.key, e.target.value)}
                                                    style={{
                                                        padding: '10px',
                                                        border: '1px solid #ddd',
                                                        borderRadius: '4px',
                                                        backgroundColor: '#fff',
                                                        color: '#333'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}

                        <div className="form-actions" style={{
                            marginTop: '30px',
                            padding: '20px',
                            borderTop: '1px solid #ddd',
                            textAlign: 'right'
                        }}>
                            <Button
                                variant="outline-secondary"
                                onClick={resetToDefault}
                                style={{
                                    marginRight: '10px',
                                    borderColor: '#6c757d',
                                    color: '#6c757d'
                                }}
                            >
                                Reset to Default
                            </Button>
                            <Button
                                variant="primary"
                                onClick={handleSave}
                                style={{
                                    backgroundColor: '#007bff',
                                    borderColor: '#007bff'
                                }}
                            >
                                Save Contact & Social Settings
                            </Button>
                        </div>
                    </div>
                </div>

                {/* Preview Section */}
                <div className="dc-tabsinfo">
                    <div className="dc-tabscontenttitle">
                        <h3>Preview</h3>
                        <p>See how your contact and social information will appear</p>
                    </div>

                    <div className="contact-preview" style={{
                        padding: '20px',
                        backgroundColor: '#f8f9fa',
                        border: '1px solid #ddd',
                        borderRadius: '8px'
                    }}>
                        <div style={{ marginBottom: '20px' }}>
                            <h5 style={{ color: '#333', marginBottom: '10px' }}>Contact Information</h5>
                            {localContactSocial.contact_email && (
                                <p style={{ margin: '5px 0', color: '#666' }}>
                                    <strong>Email:</strong> {localContactSocial.contact_email}
                                </p>
                            )}
                            {localContactSocial.contact_phone && (
                                <p style={{ margin: '5px 0', color: '#666' }}>
                                    <strong>Phone:</strong> {localContactSocial.contact_phone}
                                </p>
                            )}
                            {(localContactSocial.contact_address || localContactSocial.contact_city || localContactSocial.contact_state || localContactSocial.contact_country) && (
                                <p style={{ margin: '5px 0', color: '#666' }}>
                                    <strong>Address:</strong> {[
                                        localContactSocial.contact_address,
                                        localContactSocial.contact_city,
                                        localContactSocial.contact_state,
                                        localContactSocial.contact_country
                                    ].filter(Boolean).join(', ')}
                                </p>
                            )}
                        </div>

                        <div style={{ marginBottom: '20px' }}>
                            <h5 style={{ color: '#333', marginBottom: '10px' }}>Social Media Links</h5>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                {Object.entries(localContactSocial).map(([key, value]) => {
                                    if (key.includes('_url') && value && !key.includes('website_url')) {
                                        const platform = key.replace('_url', '').replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase());
                                        return (
                                            <a
                                                key={key}
                                                href={value}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    display: 'inline-block',
                                                    padding: '5px 10px',
                                                    backgroundColor: '#007bff',
                                                    color: 'white',
                                                    textDecoration: 'none',
                                                    borderRadius: '4px',
                                                    fontSize: '12px'
                                                }}
                                            >
                                                {platform}
                                            </a>
                                        );
                                    }
                                    return null;
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactSocial;
